import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ElementRef
} from '@angular/core';

// Servicios
import { DragulaService } from 'ng2-dragula';
// Components
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { SxBaseContainerDesigner } from '../../base/base-container-designer-component';
import {
  ColumnsAttribute
} from '../../../../types/designer-attribute-type';
import { Subscription } from 'rxjs/Subscription';
import { IDesignerFactoryService } from '../../../../services/designer-factory-interface';
import { Spacing } from '../../../modals/tabs/advanced/columns-modal-advanced.component';

@Component({
  selector: 'sx-columns-designer',
  templateUrl: './columns-designer-component.html'
})
export class SxColumnsDesigner extends SxBaseContainerDesigner
  implements OnInit, OnDestroy {
  @ViewChild('panelContainer', { read: ViewContainerRef })
  private panelContainer: ViewContainerRef;

  private subscriptions: { [id: string]: Subscription } = {};

  private columnsAtt: ColumnsAttribute;
  private advancedColumnsAtt: ColumnsAttribute;

  constructor(
    dragulaService: DragulaService,
    designerFactoryService: IDesignerFactoryService,
    container: ElementRef
  ) {
    super(dragulaService, designerFactoryService, 'SxColumns', container);
  }

  ngOnInit(): void {
    this.placeHolderContainer = this.panelContainer;

    super.ngOnInit();
    if (this.designerContext) {
      const designerRef = this;

      this.designerContext.designerAdded.subscribe(designer =>
        designerRef.designerAdded(designer)
      );
    }
  }

  loadState(controlContext: any) {
    if (controlContext == null) {
      return;
    }

    // change data type structure
    if (controlContext.colBoostrap) {
      const arr = [];
      for (let index = 0; index < controlContext.columns; index++) {
        const element = {width: controlContext.colBoostrap, color: 'default'};
        arr.push(element);
      }
      delete controlContext.colBoostrap;
      delete this.getDesignerInfo().colBoostrap;
      controlContext.columns = arr;
    }
    if (!controlContext.spacing) {
      controlContext.spacing = Spacing.Default;
    }

    controlContext.innerColumns = controlContext.columns;
    // no me conviene llamar al base
    this.id = controlContext['id'];
    for (let i = 0; i < controlContext.childs.length; i++) {
      const childInfo = controlContext.childs[i];

      const childDesigner = this.createChild(childInfo.type, childInfo.id);
      childDesigner.controlContext = childInfo;
      this.updateClassAndStyles(childDesigner, i);
    }
  }

  buildAttributes(): void {

    this.columnsAtt = new ColumnsAttribute(this.controlContext, 'columns', 'columns', 'COLUMNS');
    this.advancedColumnsAtt =
      new ColumnsAttribute(this.controlContext, 'advancedColumns', 'advancedColumns', 'COLUMNS', this.controlContext.spacing);

    this.columnsAtt.onSave.subscribe(c => this.createOrUpdateColumns(c));
    this.columnsAtt.onRaise.next(this.controlContext.innerColumns);

    this.attributes.push(this.columnsAtt);
    this.attributes.push(this.advancedColumnsAtt);

  }

  designerAdded(designer: BaseDesignerComponent): void {
    if (designer) {
      // Se termino de crear el designer
      const designerRef = this;
      this.subscriptions[designer.id + '_created'] = designer.created.subscribe(
        d => designerRef.designerCreated(d)
      );
    }
  }

  designerCreated(designer: BaseDesignerComponent): void {
    if (designer && this.childsDesigners) {
      const colIndex = this.childsDesigners.indexOf(designer);
      if (colIndex !== -1) {
        // unsuscribe
        this.subscriptions[designer.id + '_created'].unsubscribe();

        this.updateClassAndStyles(designer, colIndex);
      }
    }
  }

  createOrUpdateColumns(columnsDTO: any): void {
    const columns = columnsDTO.columns;
    const spacing = columnsDTO.spacing;
    this.controlContext.spacing = spacing;
    const oldColumns = !this.controlContext.innerColumns ? [] : this.controlContext.innerColumns;
    this.controlContext.innerColumns = columns;

    if (columns.length < oldColumns.length) {
      const unusedDesigners: BaseDesignerComponent[] = [];
      this.childsDesigners.forEach(c => {
        if (c.childsDesigners.length === 0) {
          unusedDesigners.push(c);
        }
      });
      if (unusedDesigners.length < oldColumns.length - columns.length) {
        this.controlContext.innerColumns = oldColumns;
        alert('You can not do this, there are more columns in use than the ones you want to set. FIX IT!');
        return;
      } else {
        for (let index = 0; index < oldColumns.length - columns.length; index++) {
          // retrieve the latest id
          const id = unusedDesigners[unusedDesigners.length - 1 - index].id;
          let designer = this.designerContext.designers[id];
          if (designer) {
            designer.destroy();
            designer = null;
          }
        }
      }
    }

    // Misma cantidad de columnas, no hago nada
    if (columns.length <= oldColumns.length) {
      for (let index = 0; index < this.childsDesigners.length; index++) {
        // Seteo el ancho de las columnas
        const element = this.childsDesigners[index];
        this.updateClassAndStyles(element, index);
      }
    }

    // Mas columnas que las que tenia antes
    if (columns.length > oldColumns.length || !oldColumns) {
      for (let i = 0; i < oldColumns.length; i++) {
        // Seteo el ancho de las columnas
        const designer = this.childsDesigners[i];
        this.updateClassAndStyles(designer, i);
      }
      for (let c = oldColumns.length; c < columns.length; c++) {
        const childType = 'SxSimpleContainer';
        const childId =
          this.id +
          '_' +
          childType +
          '_' +
          Object.keys(this.designerContext.allDesigners).length +
          '_' +
          c;
        const childDesigner = super.createChild(childType, childId);
        childDesigner.designerContext = this.designerContext;
      }
    }
    this.columnsAtt.onRaise.next(this.controlContext.innerColumns);
  }

  getDesignerInfo() {
    const info = super.getDesignerInfo();
    info.columns = this.controlContext.innerColumns;
    info.spacing = this.controlContext.spacing;
    return info;
  }

  updateClassAndStyles(designer, index) {
    if (this.controlContext.innerColumns[index] != null) {
      designer.container.nativeElement.className = 'col-md-' + this.controlContext.innerColumns[index].width;
      designer.backColor = this.controlContext.innerColumns[index].color;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/containers/columns-designer-component.ts